import { render } from "./VitrineWordpress.vue?vue&type=template&id=72102251&scoped=true"
import script from "./VitrineWordpress.vue?vue&type=script&lang=js"
export * from "./VitrineWordpress.vue?vue&type=script&lang=js"

import "./VitrineWordpress.vue?vue&type=style&index=0&id=72102251&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72102251"]])

export default __exports__